module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/partnerUI/partner-login/partner-login.component.scss
// module id = ./src/app/partnerUI/partner-login/partner-login.component.scss
// module chunks = main